<template>
  <CorePRG
    :url="href"
    target="_self"
    data-qa="analyses_popular_card"
    class="analyses-popular-card d-flex flex-column gr-2 pa-4 bg-gray-0 text--text text-decoration-none overflow-hidden"
    :class="isMobile ? 'rounded-lg' : 'rounded-xl'"
  >
    <div
      class="analyses-popular-card__name text--text text-left"
      :class="isMobile ? 'text-subtitle-2' : 'text-subtitle-1'"
    >
      {{ name }}
    </div>

    <div class="d-flex align-center gc-2">
      <div
        class="text--text text-left"
        :class="isMobile ? 'text-subtitle-1' : 'text-h6'"
      >
        {{ formattedPrice }}
      </div>
      <div class="text-body-2 text--text text-decoration-line-through">
        {{ formattedOldPrice }}
      </div>
    </div>

    <div class="d-flex flex-column gr-2 py-1">
      <div class="d-flex align-center text-left gc-2">
        <span class="ui-icon-clock ui-icon-fz-medium icon-secondary--text flex-shrink-0" />
        <span class="text-body-2 text-secondary--text">
          {{ duration }}
        </span>
      </div>

      <div class="d-flex align-center text-left gc-2">
        <span class="ui-icon-test-tube ui-icon-fz-medium icon-secondary--text flex-shrink-0" />
        <span class="text-body-2 text-secondary--text">
          {{ biomaterial }}
        </span>
      </div>
    </div>
  </CorePRG>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'
import formatPrice from 'src/functions/formatPrice'
import useContextStore from 'src/store/useContextStore'

const props = defineProps<{
  name: string
  href: string
  price: number
  oldPrice: number
  duration: string
  biomaterial: string
  isMobile?: boolean
}>()

const { context } = useContextStore()

const formattedPrice = computed(() => formatPrice({
  price: props.price,
  currencySymbol: context.currency.symbol,
}))

const formattedOldPrice = computed(() => formatPrice({
  price: props.oldPrice,
  currencySymbol: context.currency.symbol,
}))
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.analyses-popular-card {
  box-sizing: border-box;
  border: 1px solid $ui-kit-bg-gray-60;

  &__name {
    hyphens: auto;
    overflow-wrap: break-word;
  }
}
</style>
